<template>
    <div v-if="Object.keys(invoice).length > 0">
        <invoice-detail :invoice="invoice" :mode="mode"></invoice-detail>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "invoice-print",
    components: {
        InvoiceDetail: () =>
            import("@components/invoice/components/InvoiceDetail"),
    },
    props: {
        mode: {
            type: String,
            required: false,
            default: "print",
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("Invoices", ["invoice"]),
    },
    watch: {
        $route: {
            immediate: true,
            deep: true,
            handler(to) {
                this.getInvoice(to.params.id);
            },
        },
    },
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {
        ...mapActions("Invoices", ["getInvoice"]),
    },
};
</script>

<style scoped>
</style>